<template>
  <div>
    <v-data-table
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :headers="headers"
      :items="items"
      :search="search_form"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, 100],
      }"
      :items-per-page="20"
      :expanded.sync="expanded"
      item-key="id"
      show-expand
      class="elevation-1"
    >
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          v-if="item.permissions.change"
          small
          class="mr-3"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="item.permissions.change"
          small
          class="mr-3"
          @click="historyItem(item)"
        >
          mdi-account-badge-outline
        </v-icon>
      </template>

      <template v-slot:[`item.is_active`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon
              v-if="item.is_active"
              class="mr-1"
              v-on="on"
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              class="mr-1"
              v-on="on"
            >
              mdi-close
            </v-icon>
          </template>
          <span v-if="item.is_active">Aktívny</span>
          <span v-else>Deaktivovaný</span>
        </v-tooltip>
      </template>

      <template v-slot:top>
        <v-layout class="pa-3">
          <v-text-field
            v-model="search_form"
            label="Vyhľadať"
          />
        </v-layout>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-card class="my-2">
            <v-card-title>Informácie o SP</v-card-title>
            <v-card-text>
              <socialny-podnik-profile
                :item="item"
                :editable="false"
              />
            </v-card-text>
          </v-card>

          <v-card class="my-2">
            <v-card-title>Prejavené záujmy SP</v-card-title>
            <v-card-text>
              <socialny-podnik-table-users :items="item.zaujmy"></socialny-podnik-table-users>
            </v-card-text>
          </v-card>
        </td>
      </template>
    </v-data-table>

    <v-btn
      fab
      bottom
      left
      color="pink"
      dark
      fixed
      @click="create"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-card-title v-if="update">
          Zmena používateľa
        </v-card-title>
        <v-card-title v-else>
          Nový používateľ
        </v-card-title>

        <v-container grid-list-sm>
          <v-layout wrap>
            <v-flex xs12>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.first_name"
                    label="Názov"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.email"
                    label="Email"
                    :rules="emailRules"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="new_item.type"
                    placeholder="Typ"
                    label="Typ"
                    :items="selects.types"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-checkbox
                    v-model="new_item.is_active"
                    placeholder="Aktívny (používateľ sa môže prihlásiť do systému"
                    label="Aktívny (používateľ sa môže prihlásiť do systému"
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="
              dialog = false;
              update = false;
            "
          >
            Zrušiť
          </v-btn>

          <v-btn
            v-if="update"
            text
            @click="updateItem"
          >
            Zmeniť
          </v-btn>
          <v-btn
            v-else
            text
            @click="createItem"
          >
            Vytvoriť
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar_success"
      color="success"
      :timeout="3000"
    >
      Vytvorené
      <v-btn
        text
        @click="snackbar_success = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import SocialnyPodnikProfile from './components/SocialnyPodnikProfile.vue';
import SocialnyPodnikTableUsers from './components/SocialnyPodnikTableUsers.vue';


const apiService = new APIService();

export default {
  components: {
    SocialnyPodnikProfile,
    SocialnyPodnikTableUsers
  },

  data: () => ({
    my_only: true,
    timeout: null,
    dialog: false,
    update: false,
    loading: true,
    loading_institutions: false,
    snackbar_success: false,
    expanded: [],

    search_form: "",
    search: null,
    totalItems: 0,
    options: {},
    value: true,


    emailRules: [(v) => /.+@.+/.test(v) || "Emailová adresa má nesprávny tvar"],

    headers: [
      { text: "Interné ID", value: "id" },
      { text: "Názov", value: "first_name" },
      { text: "Email", value: "email" },
      { text: "Aktívny", value: "is_active" },
      { text: "URL", value: "url", sortable: false },
      { text: "Akcie", value: "action", sortable: false },
    ],
    selects: {
      types: [
        "SP - Sociálny podnik"
      ],
    },
    new_item: {
      first_name: "",
      email: "",
      type: "SP - Sociálny podnik",
      password: "",
      is_active: true,
    },

    institutions: [],
    items: [],
  }),

  watch: {
    search_form() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.getDataFromApi();
      }, 500);
    },
    my_only() {
      this.getDataFromApi();
    },

    options: {
      handler() {
        this.getDataFromApi();
      },
    },
    deep: true,
  },

  methods: {
    historyItem(item) {
      this.$router.push({ name: "users_history", params: { id: item.id } });
    },
    generatePassword() {
      let uuid = require("uuid");
      return uuid.v4();
    },

    editItem(item) {
      this.new_item = Object.assign({}, item);
      this.dialog = true;
      this.update = true;
    },
    create() {
      this.dialog = true;
      this.update = false;

      this.new_item.first_name = "";
      this.new_item.email = "";
      this.new_item.type = "SP - Sociálny podnik";
      this.new_item.password = "";
      this.is_active = true;
    },

    getUsers(sort, search, limit, offset) {
      this.loading = true;
      apiService.getSocialnyPodnikUsers(sort, search, limit, offset).then((response) => {
        this.items = response.results;
        this.totalItems = response.count;
        this.loading = false;
      });
    },

    updateItem() {
      // if (this.new_item.password == "") delete this.new_item.password;
      this.new_item.password = this.generatePassword();


      apiService.updateSocialnyPodnikUser(this.new_item).then(
        () => {
          this.snackbar_success = true;
          this.getDataFromApi();

          this.new_item.first_name = "";
          this.new_item.email = "";
          this.new_item.type = "SP - Sociálny podnik";
          this.new_item.password = "";

          this.dialog = false;
          this.update = false;
        },
      );
    },

    createItem() {
      this.new_item.password = this.generatePassword();

      apiService.createSocialnyPodnikUser(this.new_item).then(
        () => {
          this.snackbar_success = true;
          this.getDataFromApi();

          this.new_item.first_name = "";
          this.new_item.email = "";
          this.new_item.type = "SP - Sociálny podnik";
          this.new_item.password = "";

          this.dialog = false;
        },
      );
    },

    getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let sort = "";
      if (sortBy) {
        if (sortBy.length === 1 && sortDesc.length === 1) {
          sort = sortBy[0]
            .replace(/\./g, "__")
          if (!sortDesc[0]) sort = "-" + sort;
        }
      }

      let offset = "";
      if (itemsPerPage > 0) {
        offset = (page - 1) * itemsPerPage;
      }

      this.getUsers(sort, this.search_form, itemsPerPage, offset);
    },
  },
};
</script> 